import React from 'react'
import styled from 'styled-components'

const DriverStatBar = ({
  result,
  useTranslate,
  barColor = "#f58220",
  size = "md",
  ...rest
}) => {

  const width = result !== null ? result : 0;
  const outside = width < 10;
  const active = true;

  return (
    <BarContainer className={`driver-stat-bar size-${size}`} style={rest.style ? rest.style : {}}>
      <ResultBar
        className={`h-statistics-bar ${active && ""} ${outside && "outside"}`}
        style={{ width: `${result || 0}%`, backgroundColor: barColor }}
      >
        <span
          className={`detail ${result === null && "no-value"}`}
          style={{ left: outside ? ((result !== null && result !== 0) ? "100%" : "15px") : "15px" }}
        >
          {result !== null ? result.toFixed(0) + "%" : "–"}
        </span>
      </ResultBar>
    </BarContainer>
  )
}

export default DriverStatBar;

const BarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  border-radius: 10px;
  background-color: #f4f3f1;
  overflow: hidden;
  
  &.size-sm {
    height: 32px;
  }
  
  &.size-lg {
    height: 52px;
  }
  
  @media (min-width: 768px) {
    &.size-lg {
      height: 52px;
    }
  }
`;

const ResultBar = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  border-radius: 10px;
  font-weight: 500;
  color: #fff;
  
  &.outside {
    span {
      color: black
    }
    span:not(.detail) {
      color: black;
    }
    
    .detail {
      padding-left: 5px;
    }
  }
  
  .detail {
    position: relative;
    white-space: nowrap;
    font-size: 18px;
    
    &.no-value {
      opacity: .5;
      font-size: 13px;
    }
  }
  
  .size-sm & .detail {
    font-size: 16px;
  }
  
`;


// WEBPACK FOOTER //
// ./src/components/ui/driver-stat-bar.js